import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout route para /dashboard/$dashboardId/imoveis
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
// Usando Directory Routes: dashboard.$dashboardId.imoveis/route.tsx
// route.tsx = layout route (sempre renderizado)
// Renderiza o <Outlet /> para as rotas filhas (index.tsx, $imovelId/index.tsx, etc)
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/imoveis',
)({
  component: function ImoveisLayout() {
    return <Outlet />
  },
})
